import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubHeadings, setselectedTab } from "../../../Store/B2bslice";
import { useLocation, useNavigate } from "react-router-dom";
import { getSender } from "../../../ApiServices/Apifun";
import { Spin } from "antd";
import { Images } from "../../../Controller";
import BeneficiaryCard3 from "./BeneficiaryCard3";
import { getLocalStorageItem } from "../../../Utils";
import { Select } from "antd";

const GetRemitter3 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState("");
  const [provider, setProvider] = useState("");
  const isSearchEnabled = mobile.length === 10 && provider;

  const [loader, setLoader] = useState(false);
  const checkKyc = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const [remitterDetails, setRemitterDetails] = useState({});

  useEffect(() => {
    dispatch(setSubHeadings(""));
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    const sanitized = value.replace(/[^0-9]/g, "");
    const limitedNumbers = sanitized.slice(0, 10);
    setMobile(limitedNumbers);
  };

  const handleSearch = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("mobile", mobile);
    formdata.append("bankid", provider);
    getSender(formdata)
      .then((res) => {
        if (res.status) {
          setRemitterDetails(res.data);
        } else {
          navigate("/moneyTransfer/addRemitters", {
            state: {
              provider: provider,
              mobile: mobile,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setRemitterDetails({});
      })
      .finally(() => setLoader(false));
  };

  console.log(remitterDetails);
  const handleAdd = () => {
    // throw new Error("error occured")
    navigate("/moneyTransfer/addRemitters", {
      state: {
        provider: provider,
      },
    });
  };

  useEffect(() => {
    dispatch(setselectedTab("4"));
    if (!location.state?.allow) {
      if (memberServices?.length !== 0) {
        if (!memberServices.includes("4")) {
          navigate("/not-Available");
        }
      } else {
        navigate("/not-Available");
      }
    }
  }, []);

  return (
    <>
      <Spin spinning={loader}>
        <p className="font-bold text-xl font-sans">Remitter Search</p>
        <div className="rounded-md mt-2 px-2 h-14 md:w-1/2 flex items-center gap-2 bg-inputbg">
          <Select
            placeholder="Select Provider"
            value={provider || undefined}
            onChange={(value) => setProvider(value)}
            className="w-36"
            options={[
              { label: "FINO BANK", value: "FINO" },
              { label: "AIRTEL BANK", value: "ARTL" },
            ]}
          />

          <input
            onChange={handleChange}
            value={mobile}
            onKeyDown={(e) => {
              if (e.key === "Enter" && isSearchEnabled) {
                handleSearch();
              }
            }}
            placeholder="Enter Mobile Number"
            className="outline-none border-none w-full px-4 text-sm bg-inputbg"
          />

          <SearchOutlined
            onClick={() => isSearchEnabled && handleSearch()}
            className={`text-sm ${
              isSearchEnabled
                ? "cursor-pointer"
                : "cursor-not-allowed opacity-50"
            } bg-bsgray600 text-bswhite border border-bsgray500 rounded-full w-10 h-9 flex justify-center items-center`}
          />
        </div>
        {Object.keys(remitterDetails)?.length === 0 ||
        remitterDetails?.status_type === 2 ? (
          <div className="flex flex-col justify-center mt-32 items-center">
            <img src={Images.nodata} alt="noRemitter" />
            <p className="font-semibold text-sm ">No Remitter Found</p>
            {/* <p
              onClick={handleAdd}
              className="bg-primary cursor-pointer hover:bg-primaryhover transition-all text-bswhite p-4 mt-2 rounded-3xl font-semibold"
            >
              + Add Remitter
            </p> */}
          </div>
        ) : (
          <>
            <div className="bg-bswhite text-xs animate-fade-in font-semibold mt-2 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full place-items-start gap-2 border border-primary  p-4 rounded-md ">
              <div>
                <p>Name</p>
                <p>
                  {remitterDetails?.first_name +
                    " " +
                    remitterDetails?.last_name}
                </p>
              </div>
              <div>
                <p>Limit Available</p>
                <p className="text-green-500">
                  {remitterDetails?.limit_available}
                </p>
              </div>
              <div>
                <p>Limit Consumed</p>
                <p className="text-red-500">
                  {remitterDetails?.limit_consumed}
                </p>
              </div>
              <div>
                <p>Mobile</p>
                <p>{remitterDetails?.mobile}</p>
              </div>
              <div>
                <p>Address</p>
                <p>{remitterDetails?.city ? remitterDetails?.city : "--"}</p>
              </div>
            </div>
            <BeneficiaryCard3
              handleSearch={handleSearch}
              mobile={mobile}
              remitterDetails={remitterDetails}
              provider={provider}
            />
          </>
        )}
      </Spin>
    </>
  );
};

export default GetRemitter3;
